import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { validationMessages } from 'constants/validation'
import {
	FormControlLabel,
	Radio, RadioGroup, 
	Stack, StackProps,	
	Rating,
	TextField
} from '@mui/material'

import { Section } from 'components/controls/section'

import { SearchsDrugFormData } from 'interface/search/drug'

const scoreList = [
  { score:  4, value: 1, description: '星1' },
  { score:  8, value: 2, description: '星2' },
  { score: 10, value: 3, description: '星3' },
  { score: 12, value: 4, description: '星4' },
  { score: 16, value: 5, description: '星5' },
]

const {
  Required
} = validationMessages

const formSchema = yup.object().shape({
  drugName: yup.string().required(Required),
	isOwned: yup.boolean().required(Required),
  score: yup.number().required(Required)
})

type useSearchsDrugFormProps = {
	data?: SearchsDrugFormData
	onSubmit: (data: SearchsDrugFormData) => void
}
export const useSearchsDrugForm = ({
	data,
	onSubmit
}: useSearchsDrugFormProps) => {
	const form = useForm({
		defaultValues: data ? {
			drugName: data.drugName,
			isOwned: data.isOwned ?? false,
			score: data.score ?? 10
		} : {
			drugName: '',
			isOwned: false,
			score: 10
		},
		mode: 'onChange',
		resolver: yupResolver(formSchema)
	})
	return {
		...form,
		submit: form.handleSubmit(input => onSubmit({
			drugName: input.drugName,
			isOwned: input.isOwned,
			score: input.score,
			updateTime: data?.updateTime
		}))
	}
}

export const SearchsDrugForm = ({
	control,
	formState: { errors },
	...others
}: ReturnType<typeof useSearchsDrugForm> & StackProps) => {
	return (
		<Stack direction="column" {...others}>
			<Section label="薬剤名" labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="drugName"
					render={({ field }) => (
						<>
							<TextField
								{...field}
								variant="outlined"
								size="small"
								error={!!errors.drugName}
								helperText={errors.drugName ? errors.drugName.message : ''}
							/>
						</>
					)}
				/>
			</Section>

			<Section label="自他区分" labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="isOwned"
					render={({ field }) => (
						<RadioGroup
							row
							value={field.value}
							onChange={(event) => field.onChange(event.target.value)}
						>
							<FormControlLabel
								value={true}
								control={<Radio />}
								label="自社製品"
							/>
							<FormControlLabel
								value={false}
								control={<Radio />}
								label="他社製品"
							/>
						</RadioGroup>
					)}
				/>
			</Section>

			<Section label="重要度" labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="score"
					render={({ field }) => (
						<Rating
							value={scoreList.find(r => r.score === field.value)?.value ?? 0}
							name="score"
							onChange={(e, v) => field.onChange(e, scoreList.find(r => r.value === v)?.score ?? 10)}
						/>
					)}
				/>
			</Section>
		</Stack>
	)
}